// extracted by mini-css-extract-plugin
export default {"feBar":"style_feBar__Gvoxs"};